module.exports = __webpack_public_path__ + "img/good_checked.d262b4de.png";